import axios from "axios";
import { GET_ALL_ACTIVITIES, SET_JOB_ID, SET_UNITS, SET_CUSTOM_FIELDS, SET_ACCESS_TOKEN, SET_ACTIVITY_DROPDOWN_PARAMS, SET_CUSTOM_COMPONENTS, SET_ACTIVITY_PERFORMANCE_TABLE_INFO, SET_ACTIVITY_PERFORMANCE_FILE_LIST, SET_JOBS } from "../constants";
import moment from "moment";

const loopActivityStatus = ["pending", "overdue", "extension"];

export const getAllActivities = (activity_assignment_id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/activityAssignment/activity-performance/${activity_assignment_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const modifiedActivityData = [];
    let can_perform = true;
    let i = 0;
    for (const item of result.data?.data?.success?.activity_assignment_mappings) {
      modifiedActivityData.push({ ...item, can_perform: can_perform });
      if(item.status === "pending"){
        const check_date =  moment().isAfter(item.estimated_time)
        modifiedActivityData[i].status = check_date ? "overdue":"pending"
      }
      i++;
      if (item.is_mandatory === true && loopActivityStatus.includes(item?.status)) {
        can_perform = false;
      }
    }
    dispatch({ type: GET_ALL_ACTIVITIES, payload: modifiedActivityData });
    dispatch({ type: SET_JOB_ID, payload: result.data?.data?.success?.job_id });
    dispatch({ type: SET_UNITS, payload: JSON.parse(result.data.data.success.units || []) });
    dispatch({ type: SET_CUSTOM_FIELDS, payload: JSON.parse(result.data.data?.success?.custom_fields || {}) });

    cb(result.data);
  } catch (error) {
    cb(error.response.data);
  }
};

export const getAccessToken = () => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/reporting/getAccessToken`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    dispatch({ type: SET_ACCESS_TOKEN, payload: result.data.data.access_token });
  } catch (error) {}
};

export const getActivityCustomFields = (activity_id) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/activitycustomfields/${activity_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    let modifyData = [];
    result.data.data.map((ele) => {
      if (ele.type === "dropdown" && ele.api_parameter !== "") {
        modifyData.push(ele.api_parameter);
      }
    });

    dispatch({ type: SET_ACTIVITY_DROPDOWN_PARAMS, payload: modifyData });
    dispatch({ type: SET_CUSTOM_COMPONENTS, payload: result.data.data });
  } catch (error) {}
};

export const getActivityPerformance = (activity_assignment_mapping_id) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/activityperformance/activityAssignmentMapping/${activity_assignment_mapping_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: result.data.data } });
  } catch (error) {}
};

export const getActivityPerformanceFileList = (activity_assignment_mapping_id) => async (dispatch, getState) => {
  try {
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/activityperformance/activity_performance/files/${activity_assignment_mapping_id}`);
    dispatch({ type: SET_ACTIVITY_PERFORMANCE_FILE_LIST, payload: result.data.data });
  } catch (error) {}
};

export const getActivityPerformanceByActivity = (activity_id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, email },
    } = getState();
    const result = await axios.get(`${process.env.REACT_APP_API_URL}/activityperformance/${activity_id}/${email}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    cb(result);
  } catch (error) {}
};

export const submitActivityPerformance = (activityPerformance, filedata, userinfo, activitydata, allAssets, tableInfo, obj, type, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token, id },
    } = getState();

    axios
      .post(`${process.env.REACT_APP_API_URL}/activityperformance/`, activityPerformance, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        const fileUploads = [];

        for (const item of filedata) {
          if (item.upload.length > 0) {
            fileUploads.push(...item.upload);
          }
        }

        if (fileUploads.length !== 0) {
          var bodyFormData = new FormData();
          bodyFormData.append("activity_assignment_id", userinfo.activity_assignment_id);
          bodyFormData.append("activity_assignment_mapping_id", userinfo.activity_assignment_mapping_id);
          bodyFormData.append("activity_id", userinfo.activity_id);
          bodyFormData.append("activity_performance_id", res.data.data[0].activity_performance_id);
          for (const item of fileUploads) {
            bodyFormData.append("file", item);
          }
          try {
            await axios.post(`${process.env.REACT_APP_API_URL}/activityperformance/upload/${userinfo.activity.company_id}/${userinfo.activity_assignment_id}/${userinfo.activity_assignment_mapping_id}`, bodyFormData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            dispatch(getActivityPerformanceFileList(userinfo.activity_assignment_mapping_id));
          } catch (err) {
            console.log("Unable to upload files.");
          }
        }

        dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: res.data.performanceData } });
        request.onSuccess();



        // axios
        //   .get(`${process.env.REACT_APP_API_URL}/activityperformance/activityAssignmentMapping/${userinfo.activity_assignment_mapping_id}`, {
        //     headers: { Authorization: `Bearer ${token}` },
        //   })
        //   .then(async (result) => {
            // dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: result.data.data } });

            var date = document.getElementById("datepickr");
            var status = "";

            // This is used for save condition
            // if (type === "Save") {
            //   status = "in progress";
            // }

            // if (type === "Complete") {
              if (obj.estimated_time >= date.value) {
                status = "completed";
              } else status = "completed with delay";

              //if length is not 0 means its a container else document
              if (activitydata.based_on === "Container" && tableInfo.activity_performances.length + activityPerformance.based_on.length !== allAssets.length) {
                status = "in progress";
              }
              // else if (obj.estimated_time >= date.value) {
              //   status = "completed";
              // } else status = "completed with delay";
              // else {
              //   if (obj.estimated_time >= date.value) {
              //     status = "completed";
              //   } else status = "completed with delay";
              // }

              // if (status === "completed" || status === "completed with delay") {
              //   request.onActivityCompleted();
              // }

              if (userinfo?.loop_activity !== null && loopActivityStatus.includes(userinfo?.status)) {
                status = "in progress";
              }
            // }

            axios
              .post(
                `${process.env.REACT_APP_API_URL}/activityAssignmentMapping/status/update/${userinfo.activity_assignment_mapping_id}`,
                { status: status, user_id: id, company_id: userinfo.activity.company_id },
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              )
              .then((res) => {
                // if (type === "Save") {
                //   request.onActivityCompleted();
                // }

                // if (type === "Complete") {
                //   if (status === "completed" || status === "completed with delay") {
                //     request.onActivityCompleted();
                //   }
                // }
                request.onActivityCompleted();
                request.onError();
              })
              .catch((err) => {
                request.onError();
              });
          // })
          // .catch((err) => {
          //   request.onError();
          //   console.log(err);
          // });
      })
      .catch((err) => {
        request.failedActivityPerform();
        console.log(err);
      });
  } catch (error) {}
};

export const updateActivityPerformanceAction = (payload, filedata, userinfo, activity, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    axios
      .put(`${process.env.REACT_APP_API_URL}/activityperformance/`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        const fileUploads = [];

        for (const item of filedata) {
          if (item.upload.length > 0) {
            fileUploads.push(item.upload[0]);
          }
        }

        if (fileUploads.length !== 0) {
          await axios.delete(`${process.env.REACT_APP_API_URL}/activityperformance/multipleFileDelete/${activity.performance_id}`);
          var bodyFormData = new FormData();
          bodyFormData.append("activity_assignment_id", userinfo.activity_assignment_id);
          bodyFormData.append("activity_assignment_mapping_id", userinfo.activity_assignment_mapping_id);
          bodyFormData.append("activity_id", userinfo.activity_id);
          bodyFormData.append("activity_performance_id", activity.performance_id);
          for (const item of fileUploads) {
            bodyFormData.append("file", item);
          }
          try {
            await axios.post(`${process.env.REACT_APP_API_URL}/activityperformance/upload/${userinfo.activity.company_id}/${userinfo.activity_assignment_id}/${userinfo.activity_assignment_mapping_id}`, bodyFormData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            dispatch(getActivityPerformanceFileList(userinfo.activity_assignment_mapping_id));
          } catch (err) {
            console.log("Unable to upload files.");
          }
        }

        dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: res.data.performanceData } });
        dispatch({ type: SET_JOBS, payload: activity.custom_fields });
        request.onSuccess();
        // axios
        //   .get(`${process.env.REACT_APP_API_URL}/activityperformance/activityAssignmentMapping/${userinfo.activity_assignment_mapping_id}`, {
        //     headers: { Authorization: `Bearer ${token}` },
        //   })
        //   .then(async (result) => {
        //     dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: result.data.data } });
        //     dispatch({ type: SET_JOBS, payload: activity.custom_fields });
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //   });
      })
      .catch((err) => {
        request.onError();
      });
  } catch (error) {}
};

export const assetEntryPerformance = (payload, request) => async (dispatch, getState) => {
  try {
    const result = await axios.post(`${process.env.REACT_APP_API_URL}/assetentry/`, { asset: payload });
    request.onSuccess(result.data);
  } catch (error) {}
};

export const updateAssetEntryPerformance = (assetvalue, updateasset, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.put(`${process.env.REACT_APP_API_URL}/assetentry/${assetvalue.asset_entry_id}`, updateasset, {
      headers: { Authorization: `Bearer ${token}` },
    });
    request.onSuccess(result.data);
  } catch (error) {}
};

export const deleteAssetEntryPerformance = (asset_entry_id, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.delete(`${process.env.REACT_APP_API_URL}/assetentry/${asset_entry_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    request.onSuccess(result.data);
  } catch (error) {
    request.onError(error)
  }
};

export const deleteActivityPerformance = (id, userinfo, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    axios
      .delete(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then(async (res) => {
        await axios.delete(`${process.env.REACT_APP_API_URL}/activityperformance/multipleFileDelete/${id}`);

        request.onSuccess();

        axios
          .get(`${process.env.REACT_APP_API_URL}/activityperformance/activityAssignmentMapping/${userinfo.activity_assignment_mapping_id}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((result) => {
            dispatch({ type: SET_ACTIVITY_PERFORMANCE_TABLE_INFO, payload: { activity_performances: result.data.data } });
            axios
              .get(`${process.env.REACT_APP_API_URL}/activityAssignmentMapping/status/${userinfo.activity_assignment_mapping_id}`, {
                headers: { Authorization: `Bearer ${token}` },
              })
              .then((res) => {
                if (res.data.data.status !== "pending") {
                  axios
                    .patch(
                      `${process.env.REACT_APP_API_URL}/activityAssignmentMapping/${userinfo.activity_assignment_mapping_id}`,
                      { status: "pending" },
                      {
                        headers: { Authorization: `Bearer ${token}` },
                      }
                    )
                    .then((res) => {
                      request.setActivityStatus();
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {}
};

export const assetEntryIsPerform = (asset_id, cb) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.get(`${process.env.REACT_APP_API_URL}/assetentry/byId/${asset_id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    cb(result.data);
  } catch (error) {}
};

export const fieldValueValidation = (id, payload, request) => async (dispatch, getState) => {
  try {
    const {
      auth: { token },
    } = getState();

    const result = await axios.post(`${process.env.REACT_APP_API_URL}/validationApi/validate/${id}`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    request.onSuccess(result.data);
  } catch (error) {
    request.onError(error.response.data);
  }
};

export const markCompleted = (activitydata, tableInfo, activityPerformance, allAssets, userinfo, obj, request, showallasset) => async (dispatch, getState) => {

  const {
    auth: { id },
  } = getState();

  let status = "";
  let date = document.getElementById("datepickr");

  if (obj.estimated_time >= date.value) {
    status = "completed";
  } else status = "completed with delay";

  if (activitydata.based_on === "Container" && (showallasset.length > 0)) {
    status = "in progress";
  }

  axios
    .post(`${process.env.REACT_APP_API_URL}/activityAssignmentMapping/status/update/${userinfo.activity_assignment_mapping_id}`, { status: status, user_id: id, company_id: userinfo.activity.company_id })
    .then((res) => {
      request.onActivityCompleted();
    })
    .catch((err) => {});
};
